export default __webpack_public_path__ + "static/media/sceptre.b2ac553f.png";